export function getCoreQueryParams() {
  const qp = new URLSearchParams(window.location.search);
  const find = (key) => qp.get(key) || qp.get(key.toLowerCase()) || qp.get(key.toUpperCase());
  return {
    productId: find('productId'),
    environmentId: find('environmentId'),
    countryId: find('countryId'),
  };
}


